import { Node } from '@tiptap/core';

const IGNORE_TAGS = new Set(['THEAD', 'TBODY']);

export const HTMLNode = Node.create({
  name: 'anyhtml',
  priority: 0, // lowest priority
  content: '(anyhtml|text)*',
  atom: true,
  group: 'inline',
  inline: true, // important!

  addAttributes() {
    return {
      tag: { default: null },
      attrRecord: { default: {} },
    };
  },

  parseHTML() {
    return [
      {
        tag: '*',
        getAttrs: el => {
          const tag = el.tagName;
          if (IGNORE_TAGS.has(tag)) {
            return false;
          }

          const attrKeys = el.getAttributeNames();
          const attrs: Record<string, string> = {};
          for (const key of attrKeys) {
            const val = el.getAttribute(key);
            if (val == null) {
              continue;
            }
            attrs[key] = val;
          }

          return { attrRecord: attrs, tag };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes: { tag, attrRecord } }) {
    return [tag, attrRecord, 0];
  },
});
